/* eslint-disable no-useless-constructor, react/jsx-no-target-blank */
import React from "react";
import "./ShopWalmart.css";

class ShopWalmart extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <a
        className="shop-walmart-button"
        href="https://www.walmart.com/browse/great-value-febreze-vacuum-accessories/0/0/?_refineresult=true&_be_shelf_id=8390092&search_sort=100&facet=shelf_id:8390092"
        target="_blank"
      >
        <h3 className="shop-walmart-button-title">Shop Now</h3>
        <img
          alt="Shop Walmart"
          aria-hidden="true"
          className="shop-walmart-button-image"
          src="images/walmart-logo full.png"
        />
      </a>
    );
  }
}

export default ShopWalmart;
